//import * as blocks from '@blocks/kit'
//import TableOfProps from '../table-of-props'

export default {
  //  ...blocks,
  //  TableOfProps
}
